import { z } from "zod";
import { toFormikValidationSchema } from "zod-formik-adapter";
import { REASONS } from "../../components/unsubscribeFromEmails/constants";

const unsubscribeFormSchema = toFormikValidationSchema(
    z
        .object({
            reason: z.string().optional(),
            yourReason: z.string().optional(),
        })
        .refine(
            (data) => {
                if (data.reason === REASONS.OTHER) {
                    return !!data.yourReason;
                }
                return true;
            },
            {
                message: "UnsubscribeFromEmails.Error_YourReason_Required",
                path: ["yourReason"],
            },
        ),
);

export default unsubscribeFormSchema;
